<section class="unauthorized-layout">
  <img
    class="unauthorized-layout_image"
    src="assets/errors/unauthorized-access.svg"
    [alt]="'unauthorized.title' | translate"
  />
  <div class="unauthorized-layout_inner">
    <h1 class="unauthorized-layout_title">
      {{ 'unauthorized.title' | translate }}
    </h1>
    <p class="unauthorized-layout_subtext">
      {{ 'unauthorized.subtext' | translate }}
    </p>
  </div>
  <app-cms-pipedrive-webform-error-section
    class="unauthorized-layout_webform"
    [url]="countryUrl"
  >
  </app-cms-pipedrive-webform-error-section>
</section>
